import type { ThemeColors } from "@/lib/themes/theme.types"


export function dashboardThemeVars(theme: ThemeColors): React.CSSProperties {
  const dp = theme.dashboardPanels
  const isDark = theme.name === "dark"
  return {
    "--db-toolbar-bg": theme.bgSurface,
    "--st-topbar-text": dp.topbar.text,
    "--st-topbar-title-text": "#3B82F6",
    "--st-topbar-notif-border": theme.borderDefault,
    "--st-topbar-notif-hover-bg": dp.surfaceHover,
    "--st-notif-text": dp.topbar.notifText,
    "--st-notif-text-strong": dp.topbar.notifTextStrong,
    "--st-notif-text-muted": "#9CA3AF",
    "--st-notif-badge-blue": dp.topbar.notifBadgeBlue,
    "--st-notif-badge-red": dp.topbar.notifBadgeRed,
    "--st-notif-badge-orange": dp.topbar.notifBadgeOrange,
    "--st-notif-badge-green": dp.topbar.notifBadgeGreen,
    "--st-icon-filter": theme.iconFilterMono,
    "--db-border": theme.borderDefault,
    "--db-surface-hover": dp.surfaceHover,
    "--db-toggle-selected-bg": dp.surfaceHoverMuted,
    "--db-text-primary": dp.textPrimaryAlt,
    "--db-text-secondary": dp.textSecondary,
    "--db-text-muted": dp.textMutedAlt,
    "--db-btn-primary-bg": theme.accentPrimary,
    "--db-btn-primary-hover": dp.accentHover,
    "--db-canvas-bg": theme.bgCanvas,
    "--db-sidebar-bg": theme.bgSurface,
    "--db-sidebar-border": theme.borderDefault,
    "--db-sidebar-text": dp.filenameText,
    "--db-sidebar-hover": dp.surfaceHoverMuted,
    "--db-sidebar-text-muted": dp.mutedTextAlt,
    "--db-pinned-label": dp.strongText,
    "--db-tree-active": dp.accentStrong,
    "--db-user-header": theme.accentPrimary,
    "--db-user-header-active": theme.accentPrimaryActive,
    "--db-button-text": theme.textOnPrimary,
    "--db-branch-accent-text": "#5E94FF",
    "--db-logout-text": dp.strongText,
    "--db-sidebar-icon-filter": theme.iconFilterMono,
    "--db-content-bg": theme.bgSurface,
    "--db-section-heading": theme.accentPrimary,
    "--db-content-border": theme.borderDefault,
    "--db-card-bg": theme.bgCanvas,
    "--db-card-selected-bg": dp.cardSelectedBg,
    "--db-filename-text": dp.filenameText,
    "--db-card-border": theme.borderDefault,
    "--db-chip-bg": dp.chipBg,
    "--db-chip-border": theme.borderDefault,
    "--db-chip-text": dp.chipText,
    "--db-chip-icon-muted": dp.mutedTextAlt,
    "--db-dialog-bg": theme.bgSurface,
    "--db-dialog-text": dp.dialogText,
    "--db-dialog-text-muted": dp.mutedTextAlt,
    "--db-dialog-text-faint": dp.dialogTextFaint,
    "--db-tag-bg": dp.tagBg,
    "--db-warn-bg": dp.warnBg,
    "--db-warn-border": dp.warnBorder,
    "--db-danger-bg": dp.dangerBg,
    "--db-danger-border": dp.dangerBorder,
    "--db-icon-muted-filter": dp.iconMutedFilter,
    // Solid (not translucent) so it doesn't muddy into the dark card background — a
    // translucent amber there read as a dull brown blob with illegible default-black <mark> text.
    "--db-highlight-bg": dp.highlightBg,
    "--db-highlight-text": dp.highlightText,

    "--db-icon-overlay-color": theme.iconOverlayColor,
    "--db-icon-overlay-opacity": String(theme.iconOverlayOpacity),

    /* ── Settings Component Additions ── */
    "--db-surface": theme.bgSurface,
    "--db-accent": theme.accentPrimary,
    "--db-shadow-lg": theme.shadowLg,

// Primary Buttons (Apply, Submit, Pay)
    "--db-btn-primary-text": theme.textOnPrimary,

// CTA Button (Verify & Continue)
    "--db-cta-bg": theme.accentPrimary,
    "--db-cta-hover": dp.accentHover,
    "--db-cta-text": theme.textOnPrimary,

// Secondary / Cancel Buttons
    "--db-btn-secondary-bg": isDark ? "transparent" : theme.button.secondaryBg,
    "--db-btn-secondary-text": isDark ? theme.textPrimary : theme.button.textOnSecondary,
    "--db-btn-secondary-border": theme.borderDefault,

// MFA / Success states
    "--db-success-bg": theme.button.successBg,
    "--db-success-hover": theme.button.successHover,
    "--db-success-text": theme.button.successText,
    "--db-action-bar-bg": theme.dashboardPanels.textSecondary,
  } as React.CSSProperties
}
